import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../auth/services/auth.service';
import { DataFiltersService } from '../../services/data-filters.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'mpro-categories-consumer-message',
  templateUrl: './categories-consumer-message.component.html',
  styleUrls: ['./categories-consumer-message.component.scss'],
})
export class CategoriesConsumerComponent implements OnInit {
  private turnOffHeader =
    'Switching to categories consumer demand off' as const;
  private turnOnHeader = 'Switching to categories consumer demand' as const;
  private turnOnMessage =
    'Categories consumer demand is under development at city level and will be available soon. By navigating to categories consumer demand the current cities selection will default to the highlighted country. Do you want to proceed?' as const;
  private turnOffMessage =
    'You are now able to select cities data. Do you want to proceed?' as const;
  public isModalOpen: boolean = true;
  public title: string = '';
  public message: string = '';
  constructor(public authService: AuthService) {}

  ngOnInit(): void {
    this.authService.categoriesEnabled$.subscribe((isCategoriesEnabled) => {
      if (isCategoriesEnabled) {
        this.title = this.turnOffHeader;
        this.message = this.turnOffMessage;
      } else {
        this.title = this.turnOnHeader;
        this.message = this.turnOnMessage;
      }
    });
    this.authService.isCategoriesConsumerMessageOpen$.subscribe(
      (isModalOpen) => (this.isModalOpen = isModalOpen)
    );
  }

  public switchCategories() {
    this.authService.setCategoriesEnabled();
    this.closeModal();
  }

  public closeModal() {
    this.authService.isCategoriesConsumerMessageOpen$.next(false);
  }
}
